module.exports = __webpack_public_path__ + "static/media/C.a667b572.png";